const AddCommentOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <mask
      id="mask0_1683_11865"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1683_11865)">
      <path
        d="M8.4375 10.3125H9.5625V8.0625H11.8125V6.9375H9.5625V4.6875H8.4375V6.9375H6.1875V8.0625H8.4375V10.3125ZM1.875 15.7789V3.23081C1.875 2.85194 2.00625 2.53125 2.26875 2.26875C2.53125 2.00625 2.85194 1.875 3.23081 1.875H14.7692C15.1481 1.875 15.4688 2.00625 15.7313 2.26875C15.9938 2.53125 16.125 2.85194 16.125 3.23081V11.7692C16.125 12.1481 15.9938 12.4688 15.7313 12.7313C15.4688 12.9938 15.1481 13.125 14.7692 13.125H4.52887L1.875 15.7789ZM4.05 12H14.7692C14.8269 12 14.8798 11.9759 14.9278 11.9278C14.9759 11.8798 15 11.8269 15 11.7692V3.23081C15 3.17306 14.9759 3.12019 14.9278 3.07219C14.8798 3.02406 14.8269 3 14.7692 3H3.23081C3.17306 3 3.12019 3.02406 3.07219 3.07219C3.02406 3.12019 3 3.17306 3 3.23081V13.0386L4.05 12Z"
        fill="#535862"
      />
    </g>
  </svg>
);

export default AddCommentOutlined;
